module.exports = __webpack_public_path__ + "media/images/flags/ro-e76a6daded06b07e837dfd7d0b921408.svg";